/**
 * @private @internal
 */
export var middlewareHelper = function middlewareHelper(middlewares) {
  return function (fetchFunction) {
    return middlewares.reduceRight(function (acc, curr) {
      return curr(acc);
    }, fetchFunction) || fetchFunction;
  };
};